import * as React from 'react';
import { UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import './rewardpoint-style.css';
import { RewardPointComponentProps, RewardPointComponentHandler } from './rewardpointcomponent';
import { RewardPointCSSStyle } from './rewardpointcss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export class RewardPointViewImpl extends UIComponentViewImpl<UIDataModel>
{
 
    bindHandlers()
    {   
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    draw(props: RewardPointComponentProps, state: UIComponentState, cssStyle: RewardPointCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
             
              <div id="reward-point-wrapper">
            {
                this.getWebView(props, state, cssStyle)
            }
            </div>
            <div id="reward-point-col-wrapper">
                        {
                            this.getMobileView(props, state, cssStyle)
                        }
            </div>
              
                {/* <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/> */}

            </div>
        );
    }

    getWebView(props: RewardPointComponentProps, state: UIComponentState, cssStyle: RewardPointCSSStyle)
    {
        let rewardPointStatement = props.context.getResources().getString(Strings.reward_point_content);
        let replaceRewardPointStatement = rewardPointStatement.replace("$rewardPoints$", props.rewardPointDto.getRewardPoint()).replace("$lastUpdated$", props.rewardPointDto.getLastUpdatedDateTime());
        return(
            <>
               <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label style={cssStyle.getTitleCSSStyle()}>{props.headerTitle}</label>
                    <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
                </div> 
                <div style={{height: "100px",textAlign: "left", borderRadius: "10px", padding: "10px", backgroundColor: "rgb(0, 49, 135)", margin: "20px"}}>
                    <label style={{width: "100%", height: "30px",fontWeight: 300,lineHeight: "30px",fontSize: "18px",color: "rgb(255, 255, 255)"}}>
                    {replaceRewardPointStatement}
                    </label>
                </div>
                {/* <div className="reward-point-main-container">
                    <div className="reward-point-container">
                        <label className="reward-point-label">
                            <b>{props.context.getResources().getString(Strings.reward_points) + ":"}</b>
                        </label>
                        <label className="reward-point-value">
                            {props.rewardPointDto.getRewardPoint()}
                        </label>
                    </div> 
                    <div id="reward-point-date-time-container">
                        <label className="reward-point-date-time-label">
                            <b>{props.context.getResources().getString(Strings.reward_point_last_updated) + ":"}</b>
                        </label>
                        <label className="reward-point-date-time-value">
                            {props.rewardPointDto.getLastUpdatedDateTime()}
                        </label>
                    </div>
                </div> */}
            </>
        );
    }

    getMobileView(props: RewardPointComponentProps, state: UIComponentState, cssStyle: RewardPointCSSStyle)
    {
        let rewardPointStatement = props.context.getResources().getString(Strings.reward_point_content);
        let replaceRewardPointStatement = rewardPointStatement.replace("$rewardPoints$", props.rewardPointDto.getRewardPoint()).replace("$lastUpdated$", props.rewardPointDto.getLastUpdatedDateTime());
        return(
            <>  
            <div style={cssStyle.getHeaderDivCSSStyle()}>
                    <label id="reward-point-col-mobile-header-title" style={cssStyle.getMobileTitleCSSStyle()}>{props.headerTitle}</label>
                    <div id="reward-point-col-mobile-header-icon" style={cssStyle.getMobileCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                        <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                    </div>
            </div> 
            <div style={{height: "100px",textAlign: "left", borderRadius: "10px", padding: "10px", backgroundColor: "rgb(0, 49, 135)", margin: "20px"}}>
                    <label style={{width: "100%", height: "30px", fontWeight: 300, lineHeight: "20px", fontSize: "14px", color: "rgb(255, 255, 255)"}}>
                    {replaceRewardPointStatement}
                    </label>
            </div>
            {/* <div className="reward-point-main-container">
                <div className="reward-point-container">
                    <label className="reward-point-label">
                        <b>{props.context.getResources().getString(Strings.reward_points) + ":"}</b>
                    </label>
                    <label className="reward-point-value">
                        {props.rewardPointDto.getRewardPoint()}
                    </label>
                </div> 
                <div id="reward-point-date-time-container">
                    <label className="reward-point-date-time-label">
                        <b>{props.context.getResources().getString(Strings.reward_point_last_updated) + ":"}</b>
                    </label>
                    <label className="reward-point-date-time-value">
                        {props.rewardPointDto.getLastUpdatedDateTime()}
                    </label>
                </div>
            </div> */}
            </>
        );
    }
   
    private onCloseClick()
    {
        (this.getUIComponentHandler() as RewardPointComponentHandler).closePopup();
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/rewardpoint/rewardpointview.tsx